<template>
  <div>
    <search-sale-agent-monthly-performance
      statistic-type="additional"
      @submit="submitSearch"
    />

    <a-table
      :scroll="{ x: 'max-content' }"
      size="middle"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      row-key="id"
    />

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import SearchSaleAgentMonthlyPerformance from '@/views/sale_monthly_performances/info/Search'
import { findSaleAgentMonthlyAdditionalPerformances } from '@/api/sale_monthly_performance'
import { formatCurrency } from '@/utils/filter'
import { canViewSaleCostProfit } from '@/utils/sale_monthly_performance'

export default {
  name: 'SaleMonthlyPerformanceInfoAdditionalList',
  components: {
    Pagination,
    SearchSaleAgentMonthlyPerformance
  },
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      data: [],
      loading: true,
      pagination: {
        total_count: 0
      },
      query: {}
    }
  },
  computed: {
    canViewCostProfit() {
      return canViewSaleCostProfit(this.$store.getters.userRole)
    },
    columns() {
      const cols = [
        {
          title: '客户名称',
          dataIndex: 'agent_name'
        },
        {
          title: '账单类型',
          dataIndex: 'bill_type'
        },
        {
          title: '项目批次',
          dataIndex: 'agent_bill_no'
        },
        {
          title: '账单金额(元)',
          customRender: formatCurrency,
          dataIndex: 'amount'
        }
      ]
      if (this.canViewCostProfit) {
        cols.push(
          {
            title: '成本核算(元)',
            customRender: formatCurrency,
            dataIndex: 'cost'
          },
          {
            title: '利润核算(元)',
            customRender: formatCurrency,
            dataIndex: 'profit'
          }
        )
      }
      cols.push(
        {
          title: '套餐费用(元)',
          customRender: formatCurrency,
          dataIndex: 'product_amount'
        },
        {
          title: '模组费用(元)',
          customRender: formatCurrency,
          dataIndex: 'module_amount'
        },
        {
          title: 'CPE费用(元)',
          customRender: formatCurrency,
          dataIndex: 'cpe_amount'
        },
        {
          title: '卡板费用(元)',
          customRender: formatCurrency,
          dataIndex: 'card_amount'
        },
        {
          title: '卡数',
          dataIndex: 'cards_count'
        },
        {
          title: '模组数量',
          dataIndex: 'modules_count'
        },
        {
          title: 'CPE数量',
          dataIndex: 'cpes_count'
        },
        {
          title: '账单时间',
          dataIndex: 'agent_bill_time'
        }
      )
      return cols
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    submitSearch(search) {
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findSaleAgentMonthlyAdditionalPerformances(this.id, this.query).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    }
  }
}
</script>
